import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = {
  key: 1,
  class: "block-2"
}
const _hoisted_3 = { class: "block-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingPanel = _resolveComponent("SettingPanel")!
  const _component_CardPanel = _resolveComponent("CardPanel")!
  const _component_NLPanel = _resolveComponent("NLPanel")!
  const _component_CreateRuleModal = _resolveComponent("CreateRuleModal")!
  const _component_RefineModel = _resolveComponent("RefineModel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.chooseCard)
      ? (_openBlock(), _createBlock(_component_SettingPanel, {
          key: 0,
          chooseCard: _ctx.chooseCard,
          csvData: _ctx.csvData,
          sequenceRules: _ctx.sequenceRules,
          conditionRules: _ctx.conditionRules,
          multiConditionRules: _ctx.multiConditionRules,
          lookupRules: _ctx.lookupRules,
          onUpdateRule: _ctx.handleRuleUpdate,
          onMultiConditionOrderUpdated: _ctx.handleMultiConditionOrderUpdated
        }, null, 8, ["chooseCard", "csvData", "sequenceRules", "conditionRules", "multiConditionRules", "lookupRules", "onUpdateRule", "onMultiConditionOrderUpdated"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "default-message" }, "Please Choose Validation Card", -1)
        ]))),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CardPanel, {
        filterCards: _ctx.filterCards,
        chooseCard: _ctx.chooseCard,
        onCardClick: _ctx.handleCardClick,
        onDeleteCard: _ctx.handleDeleteCard,
        onCreateRule: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCreateRuleModal = true))
      }, null, 8, ["filterCards", "chooseCard", "onCardClick", "onDeleteCard"]),
      _createVNode(_component_NLPanel, {
        ref: "nlPanel",
        chooseCard: _ctx.chooseCard,
        onRulesUpdated: _ctx.handleRulesUpdated,
        onPreviewRefine: _ctx.handleNlPreview
      }, null, 8, ["chooseCard", "onRulesUpdated", "onPreviewRefine"])
    ]),
    (_ctx.showCreateRuleModal)
      ? (_openBlock(), _createBlock(_component_CreateRuleModal, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateRuleModal = false)),
          onSubmit: _ctx.handleCreateRuleSubmit
        }, null, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.showNlRefineModal)
      ? (_openBlock(), _createBlock(_component_RefineModel, {
          key: 3,
          isInvalid: _ctx.nlIsInvalid,
          selectedData: _ctx.nlSelectedData,
          refineResult: _ctx.nlRefineResult,
          onClose: _ctx.handleNlRefineClose,
          onSubmit: _ctx.handleNlRefineSubmit
        }, null, 8, ["isInvalid", "selectedData", "refineResult", "onClose", "onSubmit"]))
      : _createCommentVNode("", true)
  ]))
}